<script>
import '@/assets/css/scourt.css'

export default {
  name: 'scourtHeader',
}
</script>

<template>
  <div class="scourt">
    <router-link to="/scourt">
      <div class="logo_wrap">
        <img src="@/assets/img/scourt/logo.png" />
      </div>
      <img src="@/assets/img/scourt/scourt_banner_250714.png" />
    </router-link>
  </div>
</template>